module.exports = __webpack_public_path__ + "static/img/17@2x.5fced280.png";